import React, { useState, useEffect } from "react";
import "../../../../../../../styles/shared/user-list.css";

// components imports
import WarehouseClientsTable from "../../../../../../../Components/BoltTable/BoltTable";
// apis imports
import { getClientsByWarehouses } from "../../../../../../../services/AdminServices/Users/users.services";
// library imports
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import { useTranslation } from "react-i18next";

const WarehouseClientList = ({ open, setOpen, setSnack }) => {
  const { t } = useTranslation("admin");
  const [warehouseClients, setWarehouseClients] = useState([]);

  const fetchClientsByWarehouses = async (page, perPage, filter) => {
    const response = await getClientsByWarehouses(
      open.id,
      page,
      perPage,
      filter
    );
    if (!response.error) {
      setWarehouseClients(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text:
            response?.error?.response?.data?.message || t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const columns = [
    {
      id: 1,
      label: t("users.userName"),
      render: (row) => <>{row?.username ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("users.businessName"),
      render: (row) => <>{row?.business_name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("users.email"),
      render: (row) => <>{row?.email ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("users.balance"),
      render: (row) => <>{row?.balance ?? "-"}</>,
      width: "200px",
    },
  ];

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="prdtable__hist_modal">
          <div
            className="prdtable__hist_modalheading history__product_heading  history__main_heading"
            style={{
              border: "none",
            }}
          >
            {t("users.warehouseClients")}
          </div>
          <div className="prdtable__hist_modalheading history__product_heading history__sub_heading">
            {open?.name ?? ""} ({open?.code ?? ""})
          </div>
          <div className="prdtable__hist_modalcontent history__product_content">
            <WarehouseClientsTable
              tableId="warehouseClientsTableForAdmin"
              message={t("users.noWarehouseClientsAvailableTo")}
              searchPlaceHolder={t("users.searchClients")}
              columns={columns}
              data={warehouseClients}
              getAllData={fetchClientsByWarehouses}
              disableAutoResizing={true}
              maxHeight="100%"
            />
          </div>
          <div className=" history__product_footer">
            <div className="history__product_footer_btn" onClick={handleClose}>
              x
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default WarehouseClientList;
